var InvoiceCountry = (function ($) {
    var openInvoiceCountriesPopup = function (selectItem) {
        $(selectItem).on('click', function(){
            $.ajax({
                url: "/invoice/countries/ue",
                type: "GET",
                cache: false,
                success: function (data) {
                    $.fancybox({
                        width: 190, height: 300,
                        content: data,
                        fitToView: true,
                        autoSize: false,
                        helpers: {
                            overlay: {
                                locked: false
                            }
                        },
                        afterShow: function() {
                            selectCountry('.j-country-selection');
                        }
                    });
                }
            });
        });
    };

    var selectCountry = function (selectItem) {
         $(selectItem).on('click', function(){
            var countryVal = $(this).data('country-name');
            var countryIsocode = $(this).data('country-isocode');
            var displayName= $(this).data('country-display-name');
            $(".j-country-label").html(displayName);
            $(".j-country-name").val(countryVal);
            $(".j-country-iscode").val(countryIsocode);

            $.fancybox.close()
            window.THEME.$document.trigger('countryChangedEvent', [$(this)]);
        });
    };

    return {
        openInvoiceCountriesPopup: openInvoiceCountriesPopup
    }
}) (jQuery);

$(document).ready(function() {
    InvoiceCountry.openInvoiceCountriesPopup(".j-country-popup");
});